import * as actionTypes from "../../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  configation: null,
  is_loaded: false,
  is_loading: false,
  stimulus: [],
  vdo_otp: null
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.GET_CONFIGATION:

      return updateObject(state, {
        configation: action.payload,
        is_loading: false,
      });
    case actionTypes.GET_VDOOTP:

      return updateObject(state, {
        vdo_otp: action.payload,
        is_loading: false,
      });


    default:
      return state;
  }
};

export default reducer;
